<template>
  <div class="loader" :style="borderColor"></div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2E50D4',
    },
  },

  computed: {
    borderColor() {
      return `border-left-color: ${this.color}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
